import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled, { css } from 'styled-components'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { selectEventsData } from '../events/eventsSlice'
import MainHeadline from '../../UI/MainHeadline'
import MainDescription from '../../UI/MainDescription'
import UIButton from '../../UI/UIButton'
import { usePreloadImages } from '../../helper/usePreloadImages'


const Wrapper = styled.div`
    background: ${({isExploreSolution}) => !isExploreSolution && 'linear-gradient(180deg, rgba(255,241,232,1) 0, rgba(255,241,232,1) 50%, rgba(255,241,232,0) 100%)'};
    border-radius: 48px;
    flex-grow: 1;
    max-height: 500px;
    padding-top: 24px;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    ${({isPlatformSupport}) => isPlatformSupport && css`
        border: 3px solid #FD7B1C;
    `}
    @media only screen  and (max-width: 450px) {
        margin-top: 0px;
    }
    @media only screen and (max-width: 450px) and (max-height: 600px) {
        max-height: 400px;
    }
`;

const FeatureImg = styled.div`
    flex-grow: 1;
    position: relative;
    margin-top: 35px;
    
    &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 0 0 48px 48px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        ${({pageName}) => pageName && `background: url(../assets/screens/${pageName}.png) center bottom / contain no-repeat;`}
        ${({isPlatformSupport}) => isPlatformSupport && css`
            width: 182px;
            height: 275px;
            bottom: 40px;
            border-radius: unset;
            @media only screen and (max-width: 450px) and (max-height: 600px) {
                height: 200px;
            }
        `}
        ${({isExploreSolution}) => isExploreSolution && css`
            width: 150px;
            height: 190px;
            bottom: 40%;
            border-radius: unset;
            @media only screen and (max-width: 450px) and (max-height: 600px) {
                height: 150px;
            }
        `}
    }
`;

const FeaturesContainer = ({ history, pageName, nextUrl, pageEvent, clickEvent }) => {
    const {t} = useTranslation();
    const eventsData = useSelector(selectEventsData);
    const isExploreSolution = pageName === 'explore-solutions'
    const isPlatformSupport = pageName === 'platform-support'
    usePreloadImages(
			nextUrl === 'signup'
				? '../assets/checkmark-circle.svg'
				: `../assets/screens/${nextUrl}.png`
		);

    useEffect(() => sendAnalyticsEvents(EVENTS[pageEvent], eventsData), [pageEvent,eventsData]);

    const onContinueClick = () => {
        sendAnalyticsEvents(EVENTS[clickEvent], eventsData);
        history.push(nextUrl)
    };

    return (
        <>
            <Wrapper isExploreSolution={isExploreSolution} isPlatformSupport={isPlatformSupport}>
                <MainHeadline>{t(pageName)}</MainHeadline>
                <MainDescription customStyles={'padding: 0 5px;'}>{t(`${pageName}-description`)}</MainDescription>
                <FeatureImg pageName={pageName} isExploreSolution={isExploreSolution} isPlatformSupport={isPlatformSupport} />
            </Wrapper>
            <UIButton onClick={onContinueClick} customMargin={'30px 0 0'} bottomPosition={"16px"}/>
        </>
    )
};

export default FeaturesContainer
